<template>
	<div class="tabWrapper geoList">
		<div class="main">
			<main-table-all-back
					page-title="Geo list"
					:flag="flag"
					:headers="getHeaders"
					:filtersList="accountGeoFilters"
					:list="accountGeoListRows"
					:defaultOrder="accountGeoListOrder"
					:defaultSort="accountGeoListSort"

					:totals="accountGeoListTotals"
					:total-pages="accountGeoListTotal"
					:limit-pages="accountGeoListLimit"
					:pages="[ 15, 50, 100, 200, 500, 'All' ]"
					@updateClickButton="onClickButton"
					@updateList="onList"
					@updateRefreshFilters="onUpdateFilters(defaultFilter)"
					:isExport="false"
					:is-create="false"
					:is-settings="false"
			></main-table-all-back>
		</div>

		<preload v-if="isPreloader"></preload>

		<dialog-map
				v-if="isCoordinates"
				:isDialog="isCoordinates"
				:title="mapTitle"
				text="Approximate location of the event 📍🗺️"
				:lat="coordinates[0]"
				:lon="coordinates[1]"
				@updateCloseMap="onCloseMap"

		></dialog-map>

	</div>
</template>

<script>

import { mapActions, mapGetters } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";

// import { PERMISSIONS } from "@/constants/constants";
import { accountTabGeo } from "@/pages/Account/constants";
import DialogMap from "@/shared/DialogMap/DialogMap.vue";

export default {
	name: "AccountTabGeo",
	components: {
		DialogMap,

		MainTableAllBack,
		Preload,
	},
	props: {
		id: Number,
		isGeneralTitle: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		...mapGetters([
			"accountGeoListRows",
			"accountGeoListLimit",
			"accountGeoListOrder",
			"accountGeoListSort",
			"accountGeoListTotal",
			"accountGeoFilters",
			"accountGeoListTotals",
		]),
		getHeaders() {
			return accountTabGeo;
		},

	},
	data: () => ({
		flag: 'AccountTabStatementsItems',
		isPreloader: false,
		isSafetyStatementsView: false,
		defaultFilter: null,
		otherStatementsItem: null,
		start: false,
		isCoordinates: false,
		coordinates: false,
		mapTitle: false,
	}),

	methods: {
		...mapActions([
			'getAccountGeoList',
			'getAccountGeoListFilter',
		]),

		onCloseMap() {
			this.isCoordinates = false;
		},
		async onUpdateFilters(filters, isWithoutPayload, isWithoutFilters) {
			if (!isWithoutPayload) this.isPreloader = true;
			await this.getAccountGeoList(filters);
			if (!isWithoutFilters) await this.getAccountGeoListFilter(filters);
			if (!isWithoutPayload) this.isPreloader = false;
		},

		async onList(values) {
			this.isPreloader = true;
			const { value, flag } = values;
			this.defaultFilter = value;

			switch (flag) {
				case "sorting":
					await this.getAccountGeoList(value);
					this.isPreloader = false;
					break;
				case "page":
					await this.onUpdateFilters(value, 1, 1);
					this.isPreloader = false;
					break;
				default:

					if (this.start) {
						await this.onUpdateFilters(value, 1);
					} else {
						const filters = { id: this.id };

						await this.onUpdateFilters(filters, 1);
						this.start = true;
					}
					this.isPreloader = false;

			}
		},

		async onClickButton({ key, item }) {
			if ( key === 'coordinates_in' || key === 'coordinates_out' ) {
				this.coordinates = item[key].split(",");
				// this.coordinates = '49.839962707175104,36.696952866380926'.split(",");
				this.isCoordinates = true;
			}
			if ( key === 'coordinates_in') {
				this.mapTitle = 'Geo check-in 📍';
			}
			if ( key === 'coordinates_out') {
				this.mapTitle = 'Geo check-out 📍';
			}

		},

		setNewItem(e, id, name) {
			this.$emit('updateNewItem', { e, id, name });
		},

	},
	mounted() {

	},

	watch: {

	},
};
</script>
